export const environment = {
  production: false,
  apiUrl: "https://qa-us-api.equinemedirecord.com/api/v1",
  socketUrl: "https://qa-us-api.equinemedirecord.com",
  socketPort: ":6001",
  maxImgCount: 5,
  maxImgSize: "20971520", // in bytes
  defaultLanguage: "en-US",
  languages: ["en-US"],
  country: "usa",
  availableCountries: {
    ireland: "https://qa-ie-app.equinemedirecord.com",
    uk: "https://qa-uk-app.equinemedirecord.com",
    france: "https://qa-fr-app.equinemedirecord.com",
    usa: "https://qa-us-app.equinemedirecord.com",
    sa: "https://qa-sa-app.equinemedirecord.com"
  },
  stripeKey: "pk_test_37ClOdBt2dkVZ4Vp7wESYQZI00rxaDoF3n",
  quick_treatment: false,
  currency: "USD",
  showRegionsSelect: true, //only for USA

  ruleBookPdf: "/assets/rulebook_usa_hisa.pdf",

  ruleBookKYPdf: "/assets/rulebook_usa_ky.pdf",
  ruleBookCAPdf: "/assets/rulebook_usa_ca.pdf",

  ruleBookBCPdf: "/assets/rulebook_usa_bc.pdf",
  ruleBookBCPdPopup: "/assets/rulebook_usa_bc_popup.pdf",

  ruleBookPCPdf: "/assets/rulebook_usa_pc.pdf",
  ruleBookPCPopup: "/assets/rulebook_usa_pc_popup.pdf",

  ruleBookPKPdf: "/assets/rulebook_usa_pk.pdf",
  ruleBookPKPdfPopup: "/assets/rulebook_usa_pk_popup.pdf",

  ruleBookBC2023Pdf: "/assets/rulebook_usa_bc2023.pdf",
  ruleBookBC2023PdfPopup: "/assets/rulebook_usa_bc2023_popup.pdf",

  filterRegionForDrugs: true,
  showModalUnvaccinated: false,
  showInTheFoodChainToggle: false,
  dateFormat: "MM/dd/yyyy",
  disableTreatmentEditInstructorNotOwned: true, //If set to true instructor (trainer) can not edit treatments not created by him.

  currentCountry: "us",
  vaccinationCountries: [],

  vaccinationDocumentUrl:"https://dev.electronicvet.com/partner/vaccine_record",
};



// WEBPACK FOOTER //
// /home/vsts/work/1/s/emr-webapp/src/environments/environment.ts